export class EApiError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'EApiError';
    }
}